import cx from 'classnames';

interface Props {
  styles?: any;
  onSelect?: any;
  _showRadio?: boolean;
  id?: string;
  _selected?: boolean;
  children?: any;
}

const AccordianSectionHeader = ({
  styles,
  onSelect,
  _showRadio,
  id,
  _selected,
  children,
}: Props) => (
  <h3 onClick={onSelect} className={cx(styles['accordion-title'], 'm-nostyle')}>
    {_showRadio ? (
      <input
        type="radio"
        className={styles['radio-highlight']}
        value={id}
        name="section-selected"
        checked={_selected}
      />
    ) : null}
    {children}
  </h3>
);

export default AccordianSectionHeader;



// WEBPACK FOOTER //
// ./components/ui/accordian/accordianSectionHeader.tsx